import React from 'react';
import Container from '../../../../../Common/Container/Container';
import * as classes from './SubFooter.module.scss';
import cn from 'classnames';
import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';
import { ANY_STRING } from '../../../../../../constants/constants';
import Link from '../../../../../Common/Link/Link';

interface Props {
  shortName: string;
}

const SubFooter = ({ shortName }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={classes.wrapper}>
      <Container>
        <div className={'row'}>
          <div className={'col-sm-3 col-12 order-1 order-sm-0'}>
            {`© ${new Date().getFullYear()}`}, {shortName}
          </div>
          <div className={cn('col-sm-9 col-12 order-0 order-sm-1', classes.text)}>
            <Trans i18nKey={'subFooter.subFooterDescription'}>
              {ANY_STRING}
              <Link isExternalLink isTargetBlank path={t('subFooter.subFooterDescriptionLink')} className={classes.link}>
                {ANY_STRING}
              </Link>
              {ANY_STRING}
            </Trans>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SubFooter;
